import React, { FC } from 'react'
import ImageCard from './base/ImageCard'
import Strings from 'project/localisation'
import { membershipStrings } from 'common/strings/membership-strings'
import Button from 'components/forms/Button'
import Link from 'next/link'
import useWindowSize from 'components/util/useWindowSize'
import classNames from 'classnames'

type HotDeskCardType = {
  imageOption?: 1 | 2
}

const HotDeskCard: FC<HotDeskCardType> = ({ imageOption = 1 }) => {
  const size = useWindowSize()
  return (
    <ImageCard
      className='mt-lg-13 mt-72 mb-6'
      textAlign='center'
      padding='lg'
      reverseColumnsDesktop
      verticalAlign='center'
      imageAlt={`${membershipStrings.hotDeskAndCoWorking} icon`}
      image={
        imageOption === 1
          ? require('public/images/paul-street/paul_street-page-desks-coworking-desktop.png')
          : require('public/images/meeting-rooms/meeting-rooms-private-meeting-desktop.png')
      }
      imageClass={classNames(
        'position-lg-absolute bottom-0 end-0 max-w-xxxl-md-50 mx-auto mt-lg-0 mb-lg-0',
        {
          'me-xxl-18 px-xxl-0 px-xl-12 px-lg-8 mt-n70 mb-n14':
            imageOption === 2,
        },
        { 'img-mobile-fullwidth2 mt-n56': imageOption === 1 },
      )}
      classNameForCol1={classNames(
        'col-lg-7 ps-lg-22 pe-xxl-14 pe-lg-22 py-xxl-26 pb-14',
        imageOption === 1 ? 'pt-10' : 'pt-6',
      )}
      classNameForCol2={'col-lg-5 px-0'}
    >
      <h2 className='h2 text-semibold color-purple2 mb-6'>
        {membershipStrings.hotDeskAndCoWorking}
      </h2>
      {!size.isLgOrHigher && (
        <p className={'h3 text-semibold mb-4'}>
          {membershipStrings.virtualPhoneNumberThatTravelsWithYou}
        </p>
      )}
      <h3
        className={classNames(
          'text-semibold mb-lg-3 mb-2',
          size.isXlOrHigher ? 'h2' : 'h1 h1--ls-small-on-mobile',
        )}
      >
        {membershipStrings.hotDeskPrice}
      </h3>
      <p
        className='text-xl text-bold mb-6'
        dangerouslySetInnerHTML={{
          __html: membershipStrings.hotDeskPriceDuration,
        }}
      />
      <p
        className={'lead mb-4 px-lg-0 px-4'}
        dangerouslySetInnerHTML={{
          __html: membershipStrings.hotDeskAndCoWorkingDescription,
        }}
      />
      <Link className='a-unstyled' href='/contact-us'>
        <Button theme='secondary'>{Strings.contactUs}</Button>
      </Link>
    </ImageCard>
  )
}

export default HotDeskCard
